import {PerformanceLogger} from '../performance';
import {ENVIRONMENT_LEVEL} from '@/Constant';

export class UnderlineComment {

    key = 'UnderlineComment';

    logger: PerformanceLogger;

    constructor(logger: PerformanceLogger) {
        this.logger = logger;
    }

    logWeb =({id, data}: {id: string, data?: any}) => {
        const logger = this.logger;
        const logLevel = logger?.logLevel || '';
        if ([ENVIRONMENT_LEVEL.online, ENVIRONMENT_LEVEL.gray, ENVIRONMENT_LEVEL.qa].includes(logLevel)) {
            const opVersion = logger?.getOpVersionInfo();
            logger.feLogger({
                id,
                data: {
                    ...data,
                    opVersion,
                },
            });
        }
    };

    start(data: any) {
        this.logWeb({
            id: '80001.2.22',
            data,
        });
    }

    success(data: any) {
        this.logWeb({
            id: '80001.2.23',
            data,
        });
    }

    error(data: any) {
        this.logWeb({
            id: '80001.2.24',
            data,
        });
    }

    wsSuccess(data: any) {
        this.logWeb({
            id: '80001.2.150',
            data,
        });
    }

    handleCommentBtn(data: any) {
        this.logWeb({
            id: '80001.8.55',
            data,
        });
    }

    handelSubmitBtn(data: any) {
        this.logWeb({
            id: '80001.8.56',
            data,
        });
    }

}
